import getApiClient from '@/plugins/api-client'
import {accentInsensitiveFilter, highlightParts} from '@/helpers/textNormalizerHelper'

import availableJobCategories from '@/helpers/availableJobCategoriesHelper'

export default {
    searchProfessionals(append = false) {
        const self = this,
            api = getApiClient(self.$store)

        if (!append) {
            self.resetProfessionalsList()
        }

        if (self.citySearchInput && !self.filters['user.address.city']) {
            self.filters['user.address.city'] = self.citySearchInput.trim()
        }

        if (self.filters['user.address.city'] === '' || self.filters['user.address.city'] === null) {
            delete self.filters['user.address.city']
        }

        self.filters['fees.type'] = self.filters.types

        if (self.filters['user.name'] === '') {
            delete self.filters['user.name']
        }

        let filters = {...self.filters}

        if (this.filterVaccinationCertificate) {
            filters['exists[user.vaccinationCertificate]'] = true
        }

        if (!this.showSymplaEvents) {
            filters['user.symplaParticipations.event.id'] = []
            filters['user.symplaParticipations.profiles'] = null
        }

        if (this.showSymplaEvents) {
            filters['user.symplaParticipations.percentCompleted'] = 100;
            if (self.filters.category) {
                filters['user.symplaParticipations.profiles'] = self.filters.category
            } else {
                filters['user.symplaParticipations.profiles'] = availableJobCategories.map(category => category.code)
            }
        }

        this.$store.commit('setCastSearchFilters', filters)

        api.get(`/work_profiles`, {
            params: {
                ...filters,
                page: self.castSearch.page
            }
        })
            .then(result => {
                if (!result.data['hydra:totalItems']) {
                    self.showNoProfilesFound = true
                } else {
                    self.showNoProfilesFound = false
                }
                let data = result.data['hydra:member']
                self.$store.commit('pushCastSearchResult', data)

                self.$store.commit('castSearchReachedEnd', false)
                if (!data.length) {
                    self.$store.commit('castSearchReachedEnd', true)
                }
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadNextPage() {
        const self = this

        self.$store.commit('castSearchNextPage')
        self.filters.page++

        self.searchProfessionals(true)
    },

    resetProfessionalsList() {
        const self = this

        self.$store.commit('resetCastSearchResult')
    },

    openProfileDetails(profileId) {
        const self = this

        self.$router.push({
            name: 'CastSearchProfile',
            params: {
                id: profileId
            }
        })
    },

    goToJobCreation() {
        this.$router.push({
            name: 'ContractorJobForm'
        })
    },

    clearFilters() {
        this.filters = {
            types: [],
            category: null,
            gender: null,
            'height[gte]': null,
            'fees.type': null,
            'fees.amount[lte]': null,
            'user.address.city': null,
            'user.name': null,
            hairColor: null,
            ethnicity: null,
            'inArray[user.languages]': [],
            'user.symplaParticipations.event.id': [],
            'user.symplaParticipations.profiles': null
        }

        this.citySearchInput = null
        this.filterVaccinationCertificate = false
        this.showNoProfilesFound = false
        this.$store.commit('resetCastSearchResult')
    },

    cityFilter: accentInsensitiveFilter,

    cityHighlight: highlightParts,

    onCitySearchInput(term) {
        const self = this,
            search = (term ?? '').trim()

        self.citySearchInput = term
        clearTimeout(self.cityDebounceTimeout)

        if (!search) {
            self.cityRequestId++
            self.availableCities = []
            self.loadingCities = false
            return
        }

        if (search === self.filters['user.address.city']) {
            return
        }

        self.cityDebounceTimeout = setTimeout(() => {
            self.loadAvailableCities(search)
        }, 300)
    },

    loadAvailableCities(search) {
        const self = this,
            api = getApiClient(self.$store),
            requestId = ++self.cityRequestId

        self.loadingCities = true

        api.get('/professionals/cities', {params: {search}})
            .then(result => {
                if (requestId === self.cityRequestId) {
                    self.availableCities = result.data || []
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                if (requestId === self.cityRequestId) {
                    self.loadingCities = false
                }
            })
    },

    clearConditionalFilters() {
        this.filters['height[gte]'] = null
        this.filters['gender'] = null
    },

    getProfileCategoryLabel(category) {
        let item = this.availableJobCategories.filter(item => {
            return item.code === category
        })

        return item[0]?.label ?? category
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
                console.log(result.data)
            })
            .catch(error => {
                console.log(error)
            })
    },

    toggleVaccinationCertificateFilter() {
        this.filterVaccinationCertificate = !this.filterVaccinationCertificate
    },

    loadSymplaEvents() {
        const self = this

        if (self.symplaEvents.length) {
            return
        }

        const api = getApiClient(self.$store)

        api.get('sympla_events/list')
            .then(result => {
                self.symplaEvents = result.data['hydra:member']
                self.showSymplaEvents = true
            })
            .catch(error => {
                console.log(error)
            })
    },

    onNameFilterInput() {
        const self = this,
            name = self.filters['user.name'] ?? ''

        clearTimeout(self.nameFilterDebounceTimeout)

        if (name.length > 0 && name.length < 3) {
            return
        }

        self.nameFilterDebounceTimeout = setTimeout(() => {
            self.searchProfessionals(false)
        }, 300)
    }
}
